import * as z from 'zod';

import { booleanFormSchema, numericStringFormSchema } from '@/_schemas/generic';

import { inventorCategoryQuerySchema } from './inventory-category-query-schema';

export const inventoryCategoryFormSchema = inventorCategoryQuerySchema
  .omit({
    name: true,
  })
  .extend({
    name: z.string().min(3),
    sku_label: z.string().min(1),
    sku_start_number: numericStringFormSchema().refine((v) => v !== '', { message: "This field can't be empty" }),
    track_stock_quantities: booleanFormSchema(),
    track_serial_numbers: booleanFormSchema(),
  });

export type InventoryCategoryFormSchema = z.infer<typeof inventoryCategoryFormSchema>;
